import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "Ancillary",
  [
    [
      "path",
      {
        d: "M15.29,7.99h-1.19v-1.18c0-.79-.64-1.43-1.43-1.43h-1.31c-.79,0-1.43.64-1.43,1.43v1.18h-1.18c-.79,0-1.43.64-1.43,1.44v1.31c0,.79.64,1.43,1.43,1.43h1.18v1.18c0,.79.64,1.43,1.43,1.43h1.31c.79,0,1.43-.64,1.43-1.43v-1.18h1.19c.79,0,1.43-.64,1.43-1.43v-1.31c0-.79-.64-1.44-1.43-1.44ZM10.7,10.61h-1.84v-1.06h1.84c.2,0,.4-.08.55-.23.15-.15.23-.35.23-.55v-1.84h1.06v1.84c0,.43.35.78.78.78h1.84v1.06h-1.84c-.43,0-.78.35-.78.78v1.84h-1.06v-1.84c0-.43-.35-.78-.78-.78Z",
      },
    ],
    [
      "path",
      {
        d: "M21.18,1.44H2.84C1.33,1.44.1,2.67.1,4.19v11.79c0,1.51,1.23,2.74,2.74,2.74h5.95l-.4,2.37h-2.28c-.43,0-.78.35-.78.78s.35.78.78.78h11.79c.43,0,.78-.35.78-.78s-.35-.78-.78-.78h-2.28l-.4-2.37h5.95c1.51,0,2.74-1.23,2.74-2.74V4.19c0-1.51-1.23-2.74-2.74-2.74ZM14.04,21.09h-4.06l.4-2.37h3.26l.4,2.37ZM22.36,15.97c0,.65-.53,1.18-1.18,1.18H2.84c-.65,0-1.18-.53-1.18-1.18V4.19c0-.65.53-1.18,1.18-1.18h18.33c.65,0,1.18.53,1.18,1.18v11.79Z",
      },
    ],
  ],
  "currentColor"
);
